import { inject, Injectable } from '@angular/core';
import {
  ChildPage,
  MainNavigationItem,
  MobileNavItem,
  MobileNavItemLinks,
  SecondaryLinksSEO
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  checkStringValueNull,
  ChildPageAem,
  getPrimaryNavigationId,
  getSecondaryNavigationId,
  HeaderFooterMachCore,
  MainNavigationAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  PrimaryId,
  SecondaryId
} from '../../constants/navigation-links/navigation-linkts-constants';
import { NavigationLinksAdapterService } from '../navigation-links/navigation-links-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class WidgetNavigationLinksAdapterService {
  navigationLinkAdapterService = inject(NavigationLinksAdapterService);

  getContent(content: HeaderFooterMachCore): MobileNavItemLinks {
    return {
      primary: this.getPrimaryDetails(content),
      secondary: this.getSecondaryDetails(content)
    };
  }

  getPrimaryDetails(content: HeaderFooterMachCore): MobileNavItem[] {
    return PrimaryId.map((id) => this.getNavigationDetails(content, id));
  }

  getSecondaryDetails(content: HeaderFooterMachCore): SecondaryLinksSEO[] {
    return SecondaryId.map((id) =>
      this.getSecondaryNavigationDetails(content, id)
    );
  }

  getNavigationDetails(
    content: HeaderFooterMachCore,
    navigationId: string
  ): MobileNavItem {
    const navItem = getPrimaryNavigationId(content, navigationId);

    return {
      id: checkStringValueNull(navItem?.id),
      label: this.navigationLinkAdapterService.transformLabel(
        checkStringValueNull(navItem?.label)
      ),
      searchUrl: checkStringValueNull(navItem?.searchUrl),
      details: {
        legacyAppUrl: checkStringValueNull(navItem?.legacyAppUrl)
      },
      redirectMobile: this.shouldRedirectMobile(navItem?.redirectMobile),
      redirectMobileUrl: checkStringValueNull(navItem?.redirectMobileUrl)
    };
  }

  private transformMainNavigation(
    items?: MainNavigationAem[]
  ): MainNavigationItem[] {
    return (
      items?.map((item) => ({
        brandLabel: item.brandLabel,
        targetUrl: item.targetUrl,
        imagePathDesktop: item.svgPathDesktop ?? '',
        openInNewTab: item.openinnewTab === 'true',
        externalImage: item.externalimage === 'true',
        altText: item.altText
      })) || []
    );
  }

  private transformChildPages(items?: ChildPageAem[]): ChildPage[] {
    return (
      items?.map((item) => ({
        pageName: item.pageName,
        pageUrl: item.pageUrl,
        openInNewTab: item.openinnewTab === 'true',
        externalImage: item.externalimage === 'true'
      })) || []
    );
  }

  getSecondaryNavigationDetails(
    content: HeaderFooterMachCore,
    id: string
  ): SecondaryLinksSEO {
    const secondaryItem = getSecondaryNavigationId(content, id);
    return {
      id: checkStringValueNull(secondaryItem?.id),
      label: checkStringValueNull(secondaryItem?.label),
      pagePath: checkStringValueNull(secondaryItem?.pagePath),
      details: {
        mainNavigation: this.transformMainNavigation(
          secondaryItem?.details?.mainNavigation
        ),
        childPages: this.transformChildPages(secondaryItem?.details?.childPages)
      },
      externalImgUrl: content.footer?.info?.externalImgPath || '',
      externalImageDescription: content.footer?.info?.footerExtDesc || ''
    };
  }

  shouldRedirectMobile(redirectMobile?: string): boolean {
    return redirectMobile === 'false' || redirectMobile === undefined
      ? false
      : true;
  }
}
